import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false




//这是用的依赖，有问题，所以暂时用的index.html网络路径
// import 'jquery/dist/jquery.min'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.min.js'


new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
